/**
 * @generated SignedSource<<993d727235219cbacb589dafce767bf8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamType = "CHECKOUT" | "FLOOR";
export type TeamAdminLayoutSetTeamModeMutation$variables = {
  hiddenIds: ReadonlyArray<string>;
  pinnedIds: ReadonlyArray<string>;
  teamId: string;
  teamType: TeamType;
};
export type TeamAdminLayoutSetTeamModeMutation$data = {
  readonly team: {
    readonly updateFeatures: {
      readonly availableFeatures: ReadonlyArray<{
        readonly __typename: string;
        readonly id: string;
        readonly isHidden: boolean;
        readonly pinnedOrder: number | null;
        readonly " $fragmentSpreads": FragmentRefs<"TeamAdminLayoutFeature_TeamFeature">;
      }>;
      readonly features: ReadonlyArray<{
        readonly id: string;
      }>;
    };
    readonly updateType: {
      readonly id: string;
      readonly type: TeamType;
    };
  };
};
export type TeamAdminLayoutSetTeamModeMutation = {
  response: TeamAdminLayoutSetTeamModeMutation$data;
  variables: TeamAdminLayoutSetTeamModeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hiddenIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pinnedIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamType"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "newHiddenIds",
    "variableName": "hiddenIds"
  },
  {
    "kind": "Variable",
    "name": "newPinnedIds",
    "variableName": "pinnedIds"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isHidden",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pinnedOrder",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "newType",
      "variableName": "teamType"
    }
  ],
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "updateType",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamAdminLayoutSetTeamModeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "TeamMutation",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "updateFeatures",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "features",
                "plural": true,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "availableFeatures",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TeamAdminLayoutFeature_TeamFeature"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamAdminLayoutSetTeamModeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "TeamMutation",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "updateFeatures",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "features",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "availableFeatures",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isTeamFeature"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TodoCategoryTeam",
                        "kind": "LinkedField",
                        "name": "todoCategoryTeam",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TodoCategory",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "icon",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "TodoCategoryTeamFeature",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5ec6eb833f188a9b7c824a574ee42d31",
    "id": null,
    "metadata": {},
    "name": "TeamAdminLayoutSetTeamModeMutation",
    "operationKind": "mutation",
    "text": "mutation TeamAdminLayoutSetTeamModeMutation(\n  $teamId: ID!\n  $teamType: TeamType!\n  $hiddenIds: [ID!]!\n  $pinnedIds: [ID!]!\n) {\n  team(id: $teamId) {\n    updateFeatures(newHiddenIds: $hiddenIds, newPinnedIds: $pinnedIds) {\n      features {\n        __typename\n        id\n      }\n      availableFeatures {\n        __typename\n        id\n        isHidden\n        pinnedOrder\n        ...TeamAdminLayoutFeature_TeamFeature\n      }\n      id\n    }\n    updateType(newType: $teamType) {\n      type\n      id\n    }\n  }\n}\n\nfragment TeamAdminLayoutFeature_TeamFeature on TeamFeature {\n  __isTeamFeature: __typename\n  id\n  __typename\n  ... on TodoCategoryTeamFeature {\n    todoCategoryTeam {\n      category {\n        icon\n        title\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3f11d327a0d4bad022c84f3d62d2461f";

export default node;
